import Image from 'next/image';
import Link from 'next/link';

import { CategoryPathType } from '@screens/Category/model/types/categoryPathsConfig';
import { Container } from '@shared/ui/Container';

import cls from './SubCategories.module.scss';

type SubCategoriesProps = {
  data: CategoryPathType;
};

export const SubCategories = ({ data }: SubCategoriesProps) => {
  return (
    <div className={cls.wrap}>
      <Container className={cls.container}>
        <div className={cls.grid}>
          {Object.values(data.subcategories).map((item) => (
            <Link
              aria-label={`Перейти на страницу категории ${item.label}`}
              key={item.url}
              className={cls.card}
              href={item.url.replaceAll('_', '-')}
            >
              <div className={cls.caption}>{item.label}</div>
              <div className={cls.image}>
                <Image
                  src={item.img}
                  fill
                  alt={'/'}
                />
              </div>
            </Link>
          ))}
        </div>
      </Container>
    </div>
  );
};
